var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'awards_item ' + _vm.code},[_c('span',{domProps:{"textContent":_vm._s(_vm.name)}}),(_vm.icon)?_c('span',{staticClass:"awards_crown_icon"},[_c('svg-inline',{attrs:{"tag":"span"}},[_c('icon',{attrs:{"icon":_vm.icon}})],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }